// extracted by mini-css-extract-plugin
module.exports = {"oPageHome":"Home_oPageHome__Eovgl","oAboutSection":"Home_oAboutSection__ih2QT","mCtaWrapper":"Home_mCtaWrapper__HGEQN"};